export class EmbedSize {
	constructor(
		public width: number,
		public height: number,
		public name: string,
		public label: string
	) {}
}
